export const hexToRgba = (hex, alpha = 1) => {
    if (!hex || typeof hex !== 'string') return `rgba(0, 0, 0, ${alpha})`;
    let cleaned = hex.replace('#', '').trim();
    if (cleaned.length === 3) {
        cleaned = cleaned.split('').map((c) => c + c).join('');
    }
    if (cleaned.length !== 6) return `rgba(0, 0, 0, ${alpha})`;
    const r = parseInt(cleaned.substring(0, 2), 16);
    const g = parseInt(cleaned.substring(2, 4), 16);
    const b = parseInt(cleaned.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
